import { formatProductName } from "./urlHelper";

export const generateSitemap = (catalog) => {
  let xml = `<?xml version="1.0" encoding="UTF-8"?>\n<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n`;

  // 📌 Добавляем главные страницы
  const staticPages = [
    { url: "/", priority: 1.0 },
    { url: "/contact", priority: 0.9 },
    { url: "/about", priority: 0.8 },
    { url: "/technology", priority: 0.7 },
    { url: "/documents", priority: 0.7 }
  ];

  staticPages.forEach(page => {
    xml += `<url>
      <loc>https://premexbel.by${page.url}</loc>
      <lastmod>${new Date().toISOString().split("T")[0]}</lastmod>
      <priority>${page.priority}</priority>
    </url>\n`;
  });

  // 📌 Добавляем товары из каталога
  catalog.forEach(category => {
    category.forEach(subCategory => {
      if (subCategory.subCatalog) {
        subCategory.subCatalog.forEach(group => {
          group.slice(1).forEach(productName => {
            xml += `<url>
              <loc>https://premexbel.by/product/${formatProductName(productName)}</loc>
              <lastmod>${new Date().toISOString().split("T")[0]}</lastmod>
              <priority>0.8</priority>
            </url>\n`;
          });
        });
      }
    });
  });

  xml += `</urlset>`;
  return xml; // ✅ Возвращаем полный XML
};
